import React from 'react';
import Modal from 'components/commons/modal/Modal';
import Button from 'components/commons/button/Button';

import Confetti from 'react-confetti';

type Props = {
  isShow: boolean;
  close: () => void;
};

const FirstLoginModal: React.FC<Props> = props => {
  return (
    <>
      {props.isShow && (
        <Confetti
          style={{ zIndex: 9999 }}
          gravity={0.07}
          numberOfPieces={350}
          initialVelocityX={0}
          initialVelocityY={20}
          wind={0}
          opacity={70}
          recycle={false}
        />
      )}
      <Modal isShow={props.isShow} close={(): void => props.close()}>
        <div className="ui-effect-fade-in-300 modal-first-login yellow">
          <div className="flex pt-3 px-3 modal-header justify-end">
            <button>
              <i
                className="icon-close text-2xl text-gray-500 text-center cursor-pointer"
                onClick={(): void => props.close()}
              />
            </button>
          </div>
          <div className="modal-body">
            <div className="modal-title-primary-block">
              <div className="modal-title-primary">初回ログイン</div>
            </div>
            <div className="modal-title-img-l"></div>
            <div className="modal-title-img-r"></div>

            <div className="modal-note-primary">おめでとうございます！</div>
            <div className="modal-note-secondary">
              アセットプランナーへようこそ！
              <br />
              さっそく始めてみましょう
            </div>

            <div className="btn-vertical-col">
              <Button fluid text onClick={(): void => props.close()}>
                閉じる
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FirstLoginModal;
